import PropTypes from 'prop-types';
import noop from '../_util/noop';
export var propTypes = {
  api: PropTypes.func,
  multiple: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType(PropTypes.array, PropTypes.object),
  param: PropTypes.object,
  dataSource: PropTypes.array
};
export var defaultProps = {
  api: undefined,
  multiple: false,
  onChange: noop,
  value: {},
  param: {},
  dataSource: []
};
//# sourceMappingURL=PropTypes.js.map
